import { render } from "./DocView.vue?vue&type=template&id=598e441c&scoped=true&ts=true"
import script from "./DocView.vue?vue&type=script&lang=ts"
export * from "./DocView.vue?vue&type=script&lang=ts"

import "./DocView.vue?vue&type=style&index=0&id=598e441c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/ch-ocean-widget/ch-ocean-widget/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-598e441c"]])

export default __exports__